import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { KeySet, KeySetProps } from './key-set/key-set';

export interface KeysProps {
  data?: KeySetProps;
  status: LoadingState;
}

export const Keys = types
  .model({
    data: types.optional(KeySet, {}),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: KeysProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setKeys(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.developers.keys,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setKeys();
    },
    async update(): Promise<void> {
      await self.setKeys();
    },
  }));

export const keys = Keys.create();
export type KeysSnapshot = SnapshotIn<typeof Keys>;
export type KeysInstance = Instance<typeof Keys>;
export default keys;
